import { Col, Form, Tab, Tabs } from "react-bootstrap";
import { CamposObrigatorios, JRow, MakeMessageError } from "../../../components/Components";
import { RootState } from "../../../app/store";
import { useDispatch, useSelector } from "react-redux";
import TerminalCarregamento from "./TerminalCarregamento";
import TerminalDescarregamento from "./TerminalDescarregamento";
import UnidadeCargaVazia from "./UnidadeCargaVazia";
import UnidadeTranspVazia from "./UnidadeTranspVazia";
import { changeModalAquatico, clearError } from "../../../features/manifestoSlice";
import { RE68 } from "../../../utils/regex";
import EmbarcacaoComboio from "./EmbarcacaoComboio";
import { TypeEmbarcacao, TypeNavegacao } from "../../../lists";

export default function ModalAquaticoForm() {
    const dispatch = useDispatch();
    const form = useSelector((state: RootState) => state.manifesto.manifesto.modal_aquatico);
    const errors = useSelector((state: RootState) => state.manifesto.listaErrors);

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        dispatch(changeModalAquatico({ [name]: value }))
        dispatch(clearError('modal_aquatico_' + name))
    }

    return (<div className="px-2">
        <JRow className="mb-3">
            <Col md>
                <Form.Group>
                    <Form.Label>* Irin do Navio</Form.Label>
                    <Form.Control type="text" name="irin" value={form.irin}
                        className={`${errors.modal_aquatico_irin?.length>0 ? "is-invalid": ""}`}
                        maxLength={10} onChange={handleChange} />
                    <MakeMessageError errors={errors} field="modal_aquatico_irin" />
                </Form.Group>
            </Col>

            <Col md>
                <Form.Group>
                    <Form.Label>* Tipo Embarcação</Form.Label>
                    <Form.Select name="tpemb" value={form.tpemb}
                     className={`${errors.modal_aquatico_tpemb?.length>0 ? "is-invalid": ""}`}
                        onChange={handleChange}
                    >
                        {TypeEmbarcacao.map(x => (
                            <option key={x.id} value={x.id}>{x.name}</option>
                        ))}
                    </Form.Select>
                    <MakeMessageError errors={errors} field="modal_aquatico_tpemb" />
                </Form.Group>
            </Col>

            <Col md>
                <Form.Group>
                    <Form.Label>* Cód. Embarcação</Form.Label>
                    <Form.Control type="text" name="cembar" value={form.cembar} maxLength={10}
                     className={`${errors.modal_aquatico_cembar?.length>0 ? "is-invalid": ""}`}
                        onChange={handleChange} />
                    <MakeMessageError errors={errors} field="modal_aquatico_cembar" />
                </Form.Group>
            </Col>

            <Col md>
                <Form.Group>
                    <Form.Label>* Nome embarcação</Form.Label>
                    <Form.Control type="text" name="xembar" value={form.xembar} maxLength={60}
                     className={`${errors.modal_aquatico_xembar?.length>0 ? "is-invalid": ""}`}
                        onChange={handleChange} />
                    <MakeMessageError errors={errors} field="modal_aquatico_xembar" />
                </Form.Group>
            </Col>

            <Col md>
                <Form.Group>
                    <Form.Label>* Número da viagem</Form.Label>
                    <Form.Control type="text" name="nviag" value={form.nviag}
                     className={`${errors.modal_aquatico_nviag?.length>0 ? "is-invalid": ""}`}
                        maxLength={10}
                        onChange={handleChange}
                        onKeyUp={(e) => {
                            const el = (e.target as HTMLInputElement);
                            el.value = el.value.replace(RE68, '');
                        }}
                    />
                    <MakeMessageError errors={errors} field="modal_aquatico_nviag" />
                </Form.Group>
            </Col>

        </JRow>
        <JRow className="mb-3">
            <Col md>
                <Form.Group>
                    <Form.Label>* Cod. Porto Embarque</Form.Label>
                    <Form.Control type="text" name="cprtemb" value={form.cprtemb} maxLength={5}
                     className={`${errors.modal_aquatico_cprtemb?.length>0 ? "is-invalid": ""}`}
                        onChange={handleChange} />
                    <MakeMessageError errors={errors} field="modal_aquatico_cprtemb" />
                </Form.Group>
            </Col>

            <Col md>
                <Form.Group>
                    <Form.Label>* Cod. Porto Destino</Form.Label>
                    <Form.Control type="text" name="cprtdest" value={form.cprtdest} maxLength={5}
                     className={`${errors.modal_aquatico_cprtdest?.length>0 ? "is-invalid": ""}`}
                        onChange={handleChange} />
                    <MakeMessageError errors={errors} field="modal_aquatico_cprtdest" />
                </Form.Group>
            </Col>

            <Col md>
                <Form.Group>
                    <Form.Label>Porto de Transbordo</Form.Label>
                    <Form.Control type="text" name="prttrans" value={form.prttrans} maxLength={60}
                     className={`${errors.modal_aquatico_prttrans?.length>0 ? "is-invalid": ""}`}
                        onChange={handleChange} />
                    <MakeMessageError errors={errors} field="modal_aquatico_prttrans" />
                </Form.Group>
            </Col>

            <Col md>
                <Form.Group>
                    <Form.Label>Tipo de Navegação</Form.Label>
                    <Form.Select name="tpnav" value={form.tpnav} onChange={handleChange}
                         className={`${errors.modal_aquatico_tpnav?.length>0 ? "is-invalid": ""}`}
                    >
                        {TypeNavegacao.map(x => (
                            <option key={x.id} value={x.id}>{x.name}</option>
                        ))}
                    </Form.Select>
                    <MakeMessageError errors={errors} field="modal_aquatico_tpnav" />
                </Form.Group>
            </Col>

        </JRow>
        <hr />
        <Tabs defaultActiveKey="modal_aquatico_terminal" id="tab-modal-aquatico"  >
            <Tab eventKey="modal_aquatico_terminal" title="Informações dos Terminais" className="pt-3">
                <JRow>
                    <Col md>
                        <TerminalCarregamento />
                    </Col>

                    <Col md>
                        <TerminalDescarregamento />
                    </Col>
                </JRow>
            </Tab>

            <Tab eventKey="modal_aquatico_unidade" title="Informações das unidades vazias" className="pt-3">
                <JRow >
                    <Col md>
                        <UnidadeCargaVazia />
                    </Col>

                    <Col md>
                        <UnidadeTranspVazia />
                    </Col>

                </JRow>
            </Tab>

            <Tab eventKey="modal_aquatico_comboi" title="Informações das embarcações de combio" className="pt-3">
                <JRow >
                    <Col md>
                        <EmbarcacaoComboio />
                    </Col>
                </JRow>
            </Tab>
        </Tabs>
        
    </div>)
}